import { render, staticRenderFns } from "./PrivacyPolicyUs.vue?vue&type=template&id=056919aa&scoped=true"
import script from "./PrivacyPolicyUs.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyUs.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyUs.vue?vue&type=style&index=0&id=056919aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056919aa",
  null
  
)

export default component.exports